import * as cx from 'classnames';
import {
    CANCEL,
    USER_STROLLERS_ADD,
    USER_STROLLERS_ADD_NEXT_STROLLER,
    USER_STROLLERS_ADD_STROLLER,
    USER_STROLLERS_CHANGE,
    USER_STROLLERS_FINISH,
    USER_STROLLERS_INIT_MESSAGE,
    USER_STROLLERS_MY_STROLLERS,
    USER_STROLLERS_SELECT_STROLLER,
} from 'mk/autogenerated/translations/UserStrollersWidget.1df1fcbed4a0683c8d19268e745c751f'
import UserStrollerItem from 'mk2/apps/blogs/components/UserStrollerItem';
import { getBlogsUserStrollerState } from 'mk2/apps/blogs/reducers';
import {
    MinStrollerSchema,
    MinUserReviewSchema,
    StrollerMinEntity,
    UserReviewMinEntity,
} from 'mk2/apps/strollers/schemas';
import Btn, { BtnSidePadding, BtnType } from 'mk2/components/Btn';
import LoadError from 'mk2/components/errors/LoadError';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { getDenormalizedEntities } from 'mk2/selectors';
import * as React from 'react';
import { connect } from 'react-redux';
import { Store } from 'redux';
import {
    userStrollersConnectionCreateTrigger,
    userStrollersConnectionRemoveTrigger,
    userStrollersFetchTrigger,
} from './UserStrollersWidget.actions';
import styles from './UserStrollersWidget.mscss';

const UserStrollersWidgetMode = {
    Add: 'add' as 'add',
    Overview: 'overview' as 'overview',
};

interface OwnState {
    isListMaintained: boolean;
    activeMode: string;
    searchResultId: number;
}

interface OwnProps {
    store?: Store<AppState>;
    postKey: string;
    isAdmin: boolean;
    username: string;
    userId: number;
}

interface StateProps {
    loadingState?: LoadingState;
    renderBlankInit: boolean;
    strollers?: StrollerMinEntity[];
    reviews?: UserReviewMinEntity[];
}

interface DispatchProps {
    onLoad?(userId: number);
    onAddMyStroller?(strollerId: number, userId: number);
    onRemoveMyStroller?(strollerId: number, userId: number);
}

type Props = OwnProps & DispatchProps & StateProps;

class UserStrollersWidget extends React.Component<Props, OwnState> {

    private selectStrollerElement: HTMLElement;
    private StrollersSelect: any;

    // todogabo presun states do redux state
    constructor(props: Props) {
        super(props);
        this.state = {
            isListMaintained: false,
            activeMode: UserStrollersWidgetMode.Overview,
            searchResultId: -1,
        };
    }

    public render() {
        const { loadingState, strollers } = this.props;
        return (
            <LoadingSwitch
                loadingState={loadingState}
                onLoad={this.onLoad}
                onRenderInit={this.renderLoadInit}
                onRenderSuccess={this.renderLoadSuccess}
                onRenderFailure={this.renderLoadFailure}
                hasData={strollers.length >= 1}
            />
        );
    }

    public componentDidUpdate() {
        if (this.state.activeMode === UserStrollersWidgetMode.Add) {
            if (!this.StrollersSelect) {
                const selectStrollerElement = this.selectStrollerElement;
                this.StrollersSelect = require('./UserStrollersWidgetSelect').StrollersSelect;
                this.StrollersSelect.init(selectStrollerElement, selectStrollerElement.parentElement, USER_STROLLERS_SELECT_STROLLER);
                selectStrollerElement.onchange = (e) => {
                    const strollerData = this.StrollersSelect.processChangeEvent(e);
                    this.setState({searchResultId: strollerData.stroller_id});
                };
            }
        }
        if (this.state.activeMode === UserStrollersWidgetMode.Overview) {
            this.StrollersSelect = undefined;
            const { strollers } = this.props;
            if (!strollers || strollers.length === 0) {
                if (this.state.isListMaintained) {
                    this.setState({isListMaintained: false});
                }
            }
        }
    }

    private onLoad = () => {
        const { userId, onLoad } =  this.props;
        onLoad(userId);
    };

    private renderLoadInit = () => {
        if (this.props.renderBlankInit) {
            return (
                <div className={styles.UserStrollersWidget__hide}/>
            );
        } else {
            return this.renderLoadSuccess();
        }
    };

    private renderLoadFailure = () => {
        return (
            <div className={styles.UserStrollersWidget}>
                <div className={styles.UserStrollersWidget__header}>
                    <h2>{USER_STROLLERS_MY_STROLLERS}</h2>
                </div>
                <LoadError
                    className={styles.UserStrollersWidget__loadFailure}
                    onRetry={this.onLoad}
                    changeTitle={false}
                />
            </div>
        );
    };

    private renderLoadSuccess = () => {
        const { request } =  this.props.store.getState();
        const { isAdmin, username, userId, strollers, reviews, onRemoveMyStroller} =  this.props;
        const canWriteReview: boolean = (request.user.username === username);
        const canMaintain: boolean = (request.user.username === username) || isAdmin;
        if (!canMaintain && !(strollers && strollers.length > 0)) {
            return (
                <div className={styles.UserStrollersWidget__hide} />
            );
        }
        return (
            <div className={styles.UserStrollersWidget}>
                <div className={styles.UserStrollersWidget__header}>
                    <h2>{USER_STROLLERS_MY_STROLLERS}</h2>
                    { this.state.activeMode === UserStrollersWidgetMode.Overview && canMaintain && strollers && strollers.length > 0 && [
                        <div key="edit-finish-sep" className={styles.UserStrollersWidget__header__sep}>•</div>,
                        !this.state.isListMaintained ? (
                            <Btn
                                key="change"
                                type={BtnType.Link}
                                label={USER_STROLLERS_CHANGE}
                                sidePadding={BtnSidePadding.None}
                                onClick={this.onClickUserStrollerListMaintenanceStart}
                                className={styles.UserStrollersWidget__header__changeBtn}
                            />
                        ) : (
                            <Btn
                                key="finish"
                                type={BtnType.Link}
                                label={USER_STROLLERS_FINISH}
                                sidePadding={BtnSidePadding.None}
                                onClick={this.onClickUserStrollerListMaintenanceExit}
                                className={styles.UserStrollersWidget__header__finishBtn}
                            />
                        ),
                        ]
                    }
                </div>

                { this.state.activeMode === UserStrollersWidgetMode.Overview && (
                    <div className={styles.UserStrollersWidget__overview}>
                        { !strollers || strollers.length === 0 ? (
                            <p className={styles.UserStrollersWidget__overview__initMsg}>{USER_STROLLERS_INIT_MESSAGE}</p>
                        ) : (
                            <div className={styles.UserStrollersWidget__overview__list}>
                                {strollers.map((stroller) => (
                                    <UserStrollerItem
                                        key={stroller.id}
                                        stroller={stroller}
                                        review={
                                            reviews.filter((r) => r.strollerSlug === stroller.slug).length !== 0 ?
                                            reviews.filter((r) => r.strollerSlug === stroller.slug)[0] : undefined
                                        }
                                        userId={userId}
                                        canWriteReview={canWriteReview}
                                        canMaintain={this.state.isListMaintained && canMaintain}
                                        onRemoveMyStroller={onRemoveMyStroller}
                                    />
                                ))}
                            </div>
                        )}
                        { canMaintain && !this.state.isListMaintained && (
                            <Btn
                                key="add_my_stroller"
                                type={BtnType.BlueTextLight}
                                className={styles.UserStrollersWidget__overview__addBtn}
                                icon="mkicon-add@2x.png"
                                label={!strollers || strollers.length === 0 ? USER_STROLLERS_ADD_STROLLER : USER_STROLLERS_ADD_NEXT_STROLLER}
                                sidePadding={BtnSidePadding.None}
                                onClick={this.onClickShowMenuToAddUserStroller}
                            />
                        )}
                    </div>
                )}
                { this.state.activeMode === UserStrollersWidgetMode.Add && canMaintain && (
                    <div className={styles.UserStrollersWidget__add}>
                        <div className={styles.UserStrollersWidget__add__suggestBoxWrapper}>
                            <select className={cx(styles.UserStrollersWidget__add__suggestBox, 'g-form-search-select')} ref={(ref) => { this.selectStrollerElement = ref; }} />
                        </div>
                        <Btn
                            className={cx(styles.MessageForm__button, styles.UserStrollersWidget__add__btn)}
                            type={BtnType.BzGreen}
                            label={USER_STROLLERS_ADD}
                            onClick={this.onClickAddUserStroller}
                        />
                        <Btn
                            className={styles.UserStrollersWidget__add__btn}
                            type={BtnType.Link}
                            label={CANCEL}
                            onClick={this.onClickCancelAddUserStroller}
                        />
                    </div>
                )}
            </div>
        );
    };

    private onClickUserStrollerListMaintenanceStart = () => {
        this.setState({ isListMaintained: true });
    };

    private onClickUserStrollerListMaintenanceExit = () => {
        this.setState({ isListMaintained: false });
    };

    private onClickShowMenuToAddUserStroller = () => {
        this.setState({ activeMode: UserStrollersWidgetMode.Add });
    };

    private onClickAddUserStroller = () => {
        const { onAddMyStroller } = this.props;
        if (this.state.searchResultId !== -1) {
            onAddMyStroller(this.state.searchResultId, this.props.userId);
        }
        this.setState({ activeMode: UserStrollersWidgetMode.Overview });
    };

    private onClickCancelAddUserStroller = () => {
        this.setState({ activeMode: UserStrollersWidgetMode.Overview });
    };
}

function mapStateToProps(state: AppState): StateProps {
    const userStrollerState = getBlogsUserStrollerState(state);
    const strollers: StrollerMinEntity[] = getDenormalizedEntities<StrollerMinEntity>(state, MinStrollerSchema, userStrollerState.strollersIds);
    const reviews: UserReviewMinEntity[] = getDenormalizedEntities<UserReviewMinEntity>(state, MinUserReviewSchema, userStrollerState.reviewIds);
    const renderBlankInit: boolean = userStrollerState.renderBlankInit;
    return {
        strollers,
        reviews,
        loadingState: userStrollerState.loadingState,
        renderBlankInit,
    };
}
const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onAddMyStroller: userStrollersConnectionCreateTrigger,
    onRemoveMyStroller: userStrollersConnectionRemoveTrigger,
    onLoad: userStrollersFetchTrigger,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserStrollersWidget);
